export const validateNotNumber = (value, name) => {
  if (/\d/.test(value)) {
    return `${name} field does not accept numbers`;
  } else {
    return `Please correct the ${name?.toLowerCase()} format`;
  }
};
